import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { IProjectEventTaskAttempt } from 'app/models/entities/IProjectEventTaskAttempt';
import { IODataResponse } from 'app/models/responses/IODataResponse';
import { IProject } from 'app/models/responses/IProject';
import { rootConfig } from 'config';
import { useODataQuery } from 'hooks/useODataQuery';
import moment from 'moment';
import { BasicFormTask } from 'pages/_dashboard/_learn/Course/components/Content/components/TaskContent/components';
import { useState } from 'react';

interface IProps {
  project: IProject;
}

const useStyles = makeStyles((theme) => ({
  link: {
    '&:hover': {
      textDecoration: 'underline',
    },
    cursor: 'pointer',
  },
  accordionDetails: {
    padding: 0,
    margin: 0,
  },
}));

const LearnerFeedback = ({ project }: IProps) => {
  const classes = useStyles();
  const [selectedFeedbackItem, setSelectedFeedbackItem] = useState<IProjectEventTaskAttempt | null>(
    null,
  );
  const { data, loading } = useODataQuery<
    IODataResponse<IProjectEventTaskAttempt[]>,
    IProjectEventTaskAttempt
  >({
    resource: 'projects',

    query: {
      expand: {
        user: {},
        projectEvent: {},
        projectEventTypeTask: {},
      },
      key: project.id,
      func: 'getLearnerFeedbacks()',
    },
  });

  return (
    <Box>
      {loading ? (
        <LinearProgress />
      ) : !data ? (
        <div style={{ textAlign: 'center' }}>
          <img
            style={{ width: '100%', maxHeight: 250, marginBottom: 10, marginTop: 30 }}
            src={`${rootConfig.staticFileRoot}/static/illustrations/undraw_anonymous_feedback_re_rc5v.svg`}
            alt='No Feedback'
          />
          <Typography variant='h6'>No feedback has yet been provided by any learners...</Typography>
        </div>
      ) : (
        <>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container spacing={1} alignItems='center'>
                <Grid item>
                  <Typography variant='h6'>LP1: Communication</Typography>
                </Grid>
                <Grid item>
                  <Chip label='1' color='secondary' size='small' />
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Learner</TableCell>
                      <TableCell>Completed</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.value?.map((task) => (
                      <TableRow key={task.id}>
                        <TableCell>
                          <Typography
                            variant='subtitle2'
                            onClick={() => setSelectedFeedbackItem(task)}
                            className={classes.link}
                          >
                            {task.user?.fullName} | {task.user?.idNumber}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          {moment(task.createdOn).format('DD MMMM YYYY hh:mmA')}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container spacing={1} alignItems='center'>
                <Grid item>
                  <Typography variant='h6'>LP2: Mathematical Literacy</Typography>
                </Grid>
                <Grid item>
                  <Chip label='0' color='default' size='small' />
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant='subtitle1' color='textSecondary'>
                No feedback has yet been provided for this section...
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container spacing={1} alignItems='center'>
                <Grid item>
                  <Typography variant='h6'>LP3: Financial Literacy</Typography>
                </Grid>
                <Grid item>
                  <Chip label='0' color='default' size='small' />
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant='subtitle1' color='textSecondary'>
                No feedback has yet been provided for this section...
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container spacing={1} alignItems='center'>
                <Grid item>
                  <Typography variant='h6'>LP4: ICT and Microsoft Windows</Typography>
                </Grid>
                <Grid item>
                  <Chip label='0' color='default' size='small' />
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant='subtitle1' color='textSecondary'>
                No feedback has yet been provided for this section...
              </Typography>
            </AccordionDetails>
          </Accordion>

          {selectedFeedbackItem && (
            <Dialog
              open={Boolean(selectedFeedbackItem)}
              onClose={() => setSelectedFeedbackItem(null)}
              fullWidth
              maxWidth='md'
            >
              <DialogTitle>{selectedFeedbackItem.user?.fullName}'s Feedback</DialogTitle>
              <DialogContent>
                <BasicFormTask task={selectedFeedbackItem.projectEventTypeTask!} />
              </DialogContent>
              <DialogActions>
                <Button
                  variant='outlined'
                  onClick={() => setSelectedFeedbackItem(null)}
                  color='primary'
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}
    </Box>
  );
};

export default LearnerFeedback;
